import $ from 'jquery';
import Shuffle from 'shufflejs';
import queryString from 'query-string';

// Convert an array-like object to a real array.
const toArray = (thing) => {
    return Array.prototype.slice.call(thing);
};

class Shuffler {
    constructor({element, selectors} = {}) {
        this.element = $(element);

        this.selectors = Object.assign({
            grid: '.js-c-tiles-grid',
            item: '.js-c-tiles-item',
            filterBtn: '.js-c-tiles-filter-btn',
            filterTaskBtn: '.js-c-tiles-filter-task-btn',
            search: '.js-c-tiles-search',
            counter: '.js-c-tiles-counter',
            showAll: '.js-c-tiles-showall'
        }, selectors);

        this.grid = this.element.find(this.selectors.grid);

        this.filters = {
            group: [],
            task: []
        };
    }

    init(options = {}) {
        this.shuffle = new Shuffle(this.grid, Object.assign({
            filterMode: Shuffle.FilterMode.ANY,
            itemSelector: '.js-c-tiles-item',
            sizer: '.js-c-tiles-sizer',
            delimiter: ', ' // Notice the space is needed in the data-groups has a space after comma
        }, options));

        window.shuffle = this;

        this._bindEvents();

        if (window.location.search) {
            const queryState = queryString.parse(window.location.search);

            this.filters.group = (typeof queryState.group === 'string' ? [queryState.group] : queryState.group) || [];
            this.filters.task = (typeof queryState.task === 'string' ? [queryState.task] : queryState.task) || [];

            this._runFilter();
            this._btnState();
        } else {
            this.shuffle.filter('initial');
        }

        this.grid.removeClass('is-initial');

        this.addSearchFilter();
        this.addShowAll();

        this.element.addClass('is-initialized');
    }

    destroy() {
        return this.shuffle.destroy();
    }

    _bindEvents() {
        window.onpopstate = this._handleHistoryBack.bind(this);

        // this.addCategoryFilter();
        this.group = toArray(document.querySelectorAll(this.selectors.filterBtn));
        this.tasks = toArray(document.querySelectorAll(this.selectors.filterTaskBtn));

        // bind events to each button
        this.group.forEach((button) => {
            button.addEventListener('click', (evt) => {
                this._onChange(evt, 'group');
            });
        }, this);

        this.tasks.forEach((button) => {
            button.addEventListener('click', (evt) => {
                this._onChange(evt, 'task');
            });
        }, this);

        this.shuffle.on(Shuffle.EventType.LAYOUT, ({ shuffle }) => {
            this._counter(shuffle);
        });
    }

    _removeFromArray(array, element) {
        return array.filter(e => e !== element);
    }

    _filterTasks(element) {
        const elmTasks = $(element).data().tasks.split(',').map(item => item.trim());

        return this.filters.task.filter((item) => {
            if (elmTasks.includes(item)) {
                return true;
            }
            return false;
        });
    }

    _mapTasks(element) {
        return $(element).data().tasks.split(',').map(item => item.trim()).map((item) => {

            if (this.filters.task.includes(item)) {
                return true;
            }

            return false;
        });
    }

    _filterItems(array) {
        return this.filters.group.filter((item) => {
            if (array.includes(item)) {
                return true;
            }
            return false;
        });
    }

    _mapItems(array) {
        return array.map((item) => {
            if (this.filters.group.includes(item)) {
                return true;
            }
            return false;
        });
    }

    // add / remove clicked items to arrays
    _onChange(evt, filtertype) {
        const filterKeyword = evt.currentTarget.dataset.filterKeyword;

        if (!filterKeyword) {
            return;
        }

        filterKeyword.toLowerCase();
        $(evt.currentTarget).toggleClass('is-active');
        // add items to active filters array
        if (this.filters[filtertype].includes(filterKeyword)) {
            this.filters[filtertype] = this.filters[filtertype].filter(function(item) {
                return item !== filterKeyword;
            });

            if (this.filters.group.length === 0) {
                this.filters.group.push('initial');
            }

        } else {
            // remove initial in array when array not empty anymore
            this.filters[filtertype] = this.filters[filtertype].filter(item => item !== 'initial');
            this.filters[filtertype].push(filterKeyword);
        }

        this._runFilter();
        this._handleURL();
        this._handleSearchReset();
    }

    _runFilter() {
        if (this.filters.group.includes('initial') && this.filters.task.length === 0) {
            this.shuffle.filter('initial');
            return;
        }

        this.shuffle.filter((element) => {

            let elementGroup = $(element).data().groups.split(',').map(item => item.trim());
            elementGroup = this._removeFromArray(elementGroup, 'initial');


            let items = [];
            let tasks = [];

            // if only task filters are selected
            if (this.filters.task.length !== 0 && (this.filters.group.length === 0 || this.filters.group[0] === 'initial') ) {
                tasks = this._filterTasks(element);

                if (tasks.length <= 0) {
                    return false;
                }
                return true;

                // if group filters are selected
            } else if (this.filters.group[0] !== 'initial' && this.filters.group.length !== 0 && this.filters.task.length === 0) {

                items = this._filterItems(elementGroup);

                if (items.length <= 0) {
                    return false;
                }
                return true;
            } else if (this.filters.group.length >= 1 && this.filters.task.length !== 0) {

                items = this._mapItems(elementGroup);
                tasks = this._mapTasks(element);

                if (items.includes(false) || tasks.includes(false)) {

                    if (items.includes(true) && tasks.includes(true)) {
                        return true;
                    }

                    return false;
                }

                return true;
            }

            return true;
        });
    }

    _handleHistoryBack(event) {
        if ( event.state !== null) {
            if (event.state.filter) {
                this.filters.group = (typeof event.state.filter.group === 'string' ? [event.state.filter.group] : event.state.filter.group) || [];
                this.filters.task = (typeof event.state.filter.task === 'string' ? [event.state.filter.task] : event.state.filter.task) || [];

                this._btnState();
                this._runFilter();
            }
        } else {
            this.shuffle.filter('initial');
            $(this.selectors.filterBtn).removeClass('is-active');
            $(this.selectors.filterTaskBtn).removeClass('is-active');
        }
    }

    _btnState() {
        $(this.selectors.filterBtn).each((e, elm) => {
            if (!this.filters.group.includes($(elm).data().filterKeyword)) {
                $(elm).removeClass('is-active');
            } else {
                $(elm).addClass('is-active');
            }
        });

        $(this.selectors.filterTaskBtn).each((e, elm) => {
            if (!this.filters.task.includes($(elm).data().filterKeyword)) {
                $(elm).removeClass('is-active');
            } else {
                $(elm).addClass('is-active');
            }
        });
    }

    _counter(shuffle) {
        const counterElm = this.element.find(this.selectors.counter);
        if (counterElm.length) {
            counterElm.text(`${shuffle.visibleItems}/${shuffle.items.length}`);
        }
    }

    addShowAll() {
        this.element.find(this.selectors.showAll).on('click', this._handleShowAllClick.bind(this));
    }

    _handleShowAllClick(evt) {
        const elm = $(evt.currentTarget);

        elm.toggleClass('is-active');

        this.shuffle.filter(!elm.hasClass('is-active') ? 'initial' : 'all');
        this._handleSearchReset();

        return false;
    }

    _handleURL() {
        if (window.history.pushState) {
            const deepUrl = `${window.location.protocol}//${window.location.host + window.location.pathname}?${queryString.stringify(this.filters)}`;
            window.history.pushState({ path: deepUrl, filter: this.filters}, '', deepUrl);
        }
    }

    addSearchFilter() {
        const searchForm = this.element.find(this.selectors.search);

        if (!searchForm.length) {
            return;
        }

        searchForm.on('submit', (evt) => {
            this._handleSearchKeyup(evt);
            return false;
        });
    }

    _handleSearchKeyup(evt) {
        const searchQuery = new FormData(evt.target).get('q').toLowerCase();
        this.shuffle.filter((searchElm) => searchElm.textContent.toLowerCase().trim().includes(searchQuery));
    }

    _handleSearchReset() {
        $(this.element).find(this.selectors.search).get(0).reset();
    }
}

export default Shuffler;
